import { render, staticRenderFns } from "./LkTable.vue?vue&type=template&id=531196ee&"
import script from "./LkTable.vue?vue&type=script&lang=js&"
export * from "./LkTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports